module.exports = __webpack_public_path__ + "img/img-04.@3x.756b703a.png";